import { 
  BussinessAboutYou,
  BussinessFinancialPosition,
  incomeDetails,
  LimitedCompany,
  otherAsset,
  otherFinancialCommitment,
  otherRecurringExpense,
  PurchaseItems,
  SoleTrader
} from '@/types'

export const initialState = {
  formId: null,
  dealerId: null,
  dealerUniqueIdentifier: null,
  isPostCall: false,
  isAAMoney: false,
  aaMembershipNumber: null,
  teslaReferenceNumber: null,
  personal: {
    yourDetails: {
      title: '',
      firstName: '',
      middleName: '',
      lastName: '',
      mobileNumber: '',
      email: '',
      dateOfBirth: ''
    },
    aboutYou: {
      purchaseItems: {
        itemType: '',
        year: '',
        purchasePrice: '',
        cashDeposit: null,
        make: '',
        model: '',
        loanTerm: '',
        repaymentFrequency: ''
      },
      isJoint: null,
      maritalStatus: '',
      dependantsNumber: null,
      driverLicenceType: '',
      driverLicenceNumber: '',
      driverLicenceVersion: '',
      // Resident and citizenship
      nzResident: null,
      countryOfBirth: '',
      countryOfCitizenship: '',
      // Your address
      address: '',
      city: '',
      ZIP: '',
      country: '',
      residenceType: '',
      timeAtAddressYears: null,
      timeAtAddressMonths: null,
      reuseForPostalAddress: true,

      // Previous address
      previousAddress: '',
      previousCity: '',
      previousZIP: '',
      previousCountry: '',
      previousTimeAtAddressYears: null,
      previousTimeAtAddressMonths: null,

      // Post address
      postAddress: '',
      postCity: '',
      postZIP: '',
      postCountry: '',

      coBorrowerDetails: {
        coBorrowerTitle: '',
        coBorrowerFirstName: '',
        coBorrowerMiddleName: '',
        coBorrowerLastName: '',
        coBorrowerPhoneNumber: '',
        coBorrowerEmail: '',
        coBorrowerDOB: '',
        coBorrowerMaritalStatus: '',
        coBorrowerDependantsNumber: null,
        coBorrowerNZResident: null,
        coBorrowerCountryOfBirth: '',
        coBorrowerCountryOfCitizenship: '',
        coBorrowerDriverLicenceType: '',
        coBorrowerDriverLicenceNumber: '',
        coBorrowerDriverLicenceVersion: '',
        coBorrowerAddress: '',
        coBorrowerCity: '',
        coBorrowerZIP: '',
        coBorrowerCountry: '',
        coBorrowerResidenceType: '',
        coBorrowerReuseForPostalAddress: true,
        coBorrowerTimeAtAddressYears: null,
        coBorrowerTimeAtAddressMonths: null,
        coBorrowerPreviousAddress: '',
        coBorrowerPreviousCity: '',
        coBorrowerPreviousZIP: '',
        coBorrowerPreviousCountry: '',
        coBorrowerPreviousTimeAtAddressYears: null,
        coBorrowerPreviousTimeAtAddressMonths: null,
        coBorrowerPostAddress: '',
        coBorrowerPostCity: '',
        coBorrowerPostZIP: '',
        coBorrowerPostCountry: '',
        isCoBorrowerLivingTogether: null // This is a new variable helper, originally not passed to the API
      }
    },
    income: {
      companyName: '',
      occupation: '',
      employmentType: '',
      timeInThisJobYears: null,
      takeHomePayFrequency: '',
      incomeAmount: null,
      spousePartnerIncome: null,
      spousePartnerFrequency: '',
      otherIncome: null, // Yes/No
      otherIncomes: [] as incomeDetails[],
      previousCompanyName: '',
      previousOccupation: '',
      previousEmploymentType: '',
      previousTimeInThisJobYears: null,
      coBorrowerCompanyName: '',
      coBorrowerOccupation: '',
      coBorrowerEmploymentType: '',
      coBorrowerTimeInThisJobYears: null,
      coBorrowerOtherIncome: null, // Yes/No
      coBorrowerPreviousCompanyName: '',
      coBorrowerPreviousOccupation: '',
      coBorrowerPreviousEmploymentType: '',
      coBorrowerPreviousTimeInThisJobYears: null,
      incomeDecreaseExpected: null,
      incomeDecreaseDetails: '',
      noPreviousEmployer: null,
      noCoBorrowerPreviousEmployer: null
    },
    financialPosition: {
      isOwnHome: null,
      mortgateValue: null,
      vehicleValue: null,
      furnitureValue: null,
      otherAssets: [] as otherAsset[],
      creditCardAmount: null,
      creditCardMonthlyPayment: null,
      mortgateBalance: null,
      mortgateMonthlyPayment: null,
      mortgageRentPaymentAmount: null,
      personalLoanAmount: null,
      personalLoanMonthlyPayment: null,
      otherFinancialCommitments: [] as otherFinancialCommitment[],
      otherAmount: null,
      otherMonthlyPayment: null,
      councilRatesExpenditureValue: null,
      homeInsuranceExpenditureValue: null,
      utilitiesExpenditureValue: null,
      livingExpenditureValue: null,
      vehicleExpenditureValue: null,
      otherRecurringExpenses: [] as otherRecurringExpense[],
      additionalNotes: ''
    },
    applicationOptions: {
      isCheckedAplyID: false,
      coBorrowerIsCheckedAplyID: false
    }
  },
  business: {
    aboutYourBusiness: {
      purchaseItems : [] as PurchaseItems[],
      businessType: '',
      preferredLoan: '',
      businessDescription: '',
      soleTrader: {
        tradingName: '',
        timeInBusinessYears: '',
        timeInBusinessMonths: '',
        haveNetProfitLastYear: true, 
        businessMainCategory: '',
        businessSubCategory: '',
        primaryNatureOfBusiness: '',
        amFarmer: false,
        lessDebt: false,
        occupation: ''
      },
      limitedCompany: {
        companyName: '',
        companyNumber: '',
        timeInBusinessYears: '',
        timeInBusinessMonths: '',
        haveNetProfitLastYear: true,
        businessMainCategory: '',
        businessSubCategory: '',
        primaryNatureOfBusiness: '',
        phone: '',
        email: '',
        physicalAddress: '',
        physicalCity: '',
        physicalZIP: '',
        physicalCountry: '',
        postalAddress: '',
        postalCity: '',
        postalZIP: '',
        postalCountry: '',
        registeredAddress: '',
        registeredCity: '',
        registeredZIP: '',
        registeredCountry: '',
        reuseForPostalAddress: false,
        reuseForRegisteredAddress: false,
        amFarmer: false,
        lessDebt: false
      }
    },
    aboutYou: {
      firstName: '',
      middleName: '',
      lastName: '',
      phone: '',
      email: '',
      dob: '',
      maritalStatus: '',
      isDependant: null,
      dependantsNumber: 0,
      dependantsAge: [],
      address: '',
      city: '',
      ZIP: '',
      country: '',
      residenceType: null,
      postAddress: '',
      postCity: '',
      postZIP: '',
      postCountry: '',
      timeAtAddressYears: null,
      timeAtAddressMonths: null,
      previousAddress: '',
      previousCity: '',
      previousZIP: '',
      previousCountry: '',
      previousTimeAtAddressYears: null,
      previousTimeAtAddressMonths: null,
      nzResident: null,
      countryOfBirth: '',
      countryOfCitizenship: '',
      countryOfAnotherCitizen: false,
      driverLicenceType: '',
      driverLicenceNumber: '',
      driverLicenceVersion: '',
      reuseForPostalAddress: true
    },
    financialPosition: {
      isOwnHome: null,
      mortgateValue: null,
      mortgateBalance: null,
      mortgateMonthlyPayment: null,
      vehicleValue: null,
      vehicleAmount: null,
      vehicleMonthlyPayment: null,
      furnitureValue: null,
      furnitureAmount: null,
      furnitureMonthlyPayment: null,
      personalLoanValue: null,
      personalLoanAmount: null,
      personalLoanMonthlyPayment: null,
      creditCardValue: null,
      creditCardAmount: null,
      creditCardMonthlyPayment: null,
      otherValue: null,
      otherAmount: null,
      otherMonthlyPayment: null,
      additionalNotes: '',
      isContinue: false
    },
    applicationOptions: {
      isCheckedAplyID: false
    }
  }
}

interface PersonalState {
  [key: string]: any // Adjust this according to the actual structure of your state
}

interface BusinessState {
  aboutYourBusiness: {
    purchaseItems: PurchaseItems[]
    businessType: string
    preferredLoan: string
    businessDescription: string
    soleTrader: SoleTrader | null
    limitedCompany: LimitedCompany | null
  },
  aboutYou: BussinessAboutYou,
  financialPosition: BussinessFinancialPosition
  applicationOptions: {
    isCheckedAplyID: boolean
  }
}

export interface FormState {
  personal: PersonalState
  business: BusinessState
  // Add other properties of the state if needed
  formId: string | null
  dealerId: number | null
  dealerUniqueIdentifier: string | null
  isAAMoney: boolean
  aaMembershipNumber: number | null
  teslaReferenceNumber: number | null
  isPostCall: boolean // <-- Add this line
}

export type FormAction = 
  | { type: 'UPDATE_PERSONAL'; step: string; payload: any }
  | { type: 'UPDATE_BUSINESS'; step: string; payload: any }
  | { type: 'UPDATE_DEALER_DETAILS'; payload: { dealerId: number | null; dealerUniqueIdentifier: string | null } }
  | { type: 'UPDATE_FORM_METADATA'; payload: { formId: string | null; dealerId: number | null } }
  | { type: 'SET_IS_POST_CALL'; payload: boolean }
  | { type: 'RESET' }

export const formReducer = (state: FormState, action: FormAction): FormState => {
  switch (action.type) {
    case 'UPDATE_PERSONAL':
      return {
        ...state,
        personal: {
          ...state.personal,
          [action.step]: action.payload
        }
      }
    case 'UPDATE_BUSINESS':
      return {
        ...state,
        business: {
          ...state.business,
          [action.step]: action.payload
        }
      }
    case 'UPDATE_DEALER_DETAILS':
      return {
        ...state,
        dealerId: action.payload.dealerId,
        dealerUniqueIdentifier: action.payload.dealerUniqueIdentifier
      }
    case 'UPDATE_FORM_METADATA':
      return {
        ...state,
        formId: action.payload.formId,
        dealerId: action.payload.dealerId
      }
    case 'SET_IS_POST_CALL':
      return {
        ...state,
        isPostCall: action.payload
      }
    case 'RESET':
      return initialState
    default:
      return state
  }
}